import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../../../base/constant";

export const loginApi = createApi({
    reducerPath: "loginApi",
    baseQuery: fetchBaseQuery({ baseUrl: `${config().BASE_URL}`}),
    tagTypes: ['login'],
    endpoints: (builder) => ({
        Login: builder.mutation<any, any>({
            query: (loginInfo) => ({
                url: "/login/",
                method: "POST",
                body: loginInfo,
            }),
        }),
        SendOtp: builder.mutation<any, any>({
            query: (loginInfo) => ({
                url: "/send-otp/",
                method: "POST",
                body: loginInfo,
            }),
        }),

        SendOtpEmail: builder.mutation<any, any>({
            query: (loginInfo) => ({
                url: "/send-otp-email/",
                method: "POST",
                body: loginInfo,
            }),
        }),
        VerifyOtp: builder.mutation<any, any>({
            query: (loginInfo) => ({
                url: "/verify-otp/",
                method: "POST",
                body: loginInfo,
            }),
        }),
        deactivate: builder.mutation<any, any>({
            query: (data) => ({
                url: `/customers/delete_request/`,
                method: "DELETE",
                body: data,
            }),
        }),
        UpdateLoginInfo: builder.mutation<any, any>({
            query: (updateLoginInfo) => ({
                url: "/update-last-login/",
                method: "POST",
                body: updateLoginInfo,
            }),
        }),
        getWhatsAppQrSession: builder.mutation<any, void>({
            query: () => ({
                url: "/whatsapp/qr-session/",
                method: "POST",
            }),
        }),
        checkWhatsAppQrStatus: builder.query<any, string>({
            query: (sessionId) => ({
                url: `/whatsapp/qr-status/${sessionId}/`,
                method: "GET",
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useDeactivateMutation,
    useSendOtpMutation,
    useSendOtpEmailMutation,
    useVerifyOtpMutation,
    useUpdateLoginInfoMutation,
    useGetWhatsAppQrSessionMutation,
    useLazyCheckWhatsAppQrStatusQuery,
} = loginApi;
